import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { _retrieveCardPaymentAcceptResult } from '~/services/actions/CSU/retrieve-card-payment-accept-result';
import { getRetrieveCardPaymentSettings } from '~/utils/payment/submit-order-settings';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { IGetPricing } from '~/interfaces/commerce-types';
import { paymentErrorRedirect } from '~/utils/payment/payment-error-redirect';
import payNow from '../checkout/pay-now';
import { PROGRESSIVE_PROCESS_COMPLETE_MESSAGE } from '~/modules/payment/progressive/constants';
import { getProgressiveTotal } from '~/modules/payment/progressive/utils';
interface SubmitProgressiveOrderProps {
  paymentConnectorId: string;
  cartId: string | null;
  orderDetails: ISalesOrderResponse;
  progressiveDetails: IGetPricing | undefined;
  router: AppRouterInstance;
  setOrderInProgress: (inProgress: boolean) => void;
  toggleSignModal: () => void;
}

export function submitProgressiveOrder({
  paymentConnectorId,
  cartId,
  orderDetails,
  progressiveDetails,
  router,
  setOrderInProgress,
  toggleSignModal,
}: SubmitProgressiveOrderProps) {
  const progressiveEventHandler = async (
    event: MessageEvent<IFrameMessageData>,
  ): Promise<void> => {
    const { message, success } = event.data;
    if (message === PROGRESSIVE_PROCESS_COMPLETE_MESSAGE && success) {
      if (!paymentConnectorId || !cartId || !orderDetails) {
        console.error(
          'Progressive Submit: Missing paymentConnectorId or cartId or orderDetails',
        );
        return;
      }
      const amountDue = getProgressiveTotal(orderDetails, null, false);
      setOrderInProgress(true);
      const applicationId =
        progressiveDetails?.LeaseDetails?.ApplicationId || 'N/A';
      _retrieveCardPaymentAcceptResult(
        getRetrieveCardPaymentSettings(
          paymentConnectorId,
          cartId,
          applicationId,
        ),
      )
        .then(async (response) => {
          const tokenizedCard = response?.TokenizedPaymentCard;
          if (response?.errCode) {
            setOrderInProgress(false);
            toggleSignModal();
            const errorCode = response.errCode;
            paymentErrorRedirect(
              errorCode,
              orderDetails.QuotationId || orderDetails.SalesId,
              router,
            );
          }
          try {
            if (tokenizedCard) {
              await payNow({
                tokenizedCard,
                isForterValidationEnabled: false,
                cartId,
                orderDetails,
                router,
                options: {
                  progressiveDetails,
                  toggleSignModal,
                  isProgressive: true,
                  setOrderInProgress,
                  progressiveAmountDue: amountDue,
                },
              });
            }
          } catch (placeOrderError) {
            console.error('Error placing order:', placeOrderError);
          }
        })
        .catch((retrievePaymentResultError) => {
          setOrderInProgress(false);
          toggleSignModal();
          console.error(
            'Error retrieving payment result:',
            retrievePaymentResultError,
          );
        });
    } else {
      console.info(
        'Progressive Submit: Invalid message or unsuccessful',
        message,
        success,
        orderDetails.QuotationId || orderDetails.SalesId,
      );
    }
  };

  return (e: MessageEvent<IFrameMessageData>) => {
    void progressiveEventHandler(e);
  };
}

interface IFrameMessageData {
  message: string;
  success: boolean;
}
